import { motion } from 'framer-motion';
import Button from '@/components/ui/Button';

const ease = [0.22, 1, 0.36, 1] as const;

interface FinalCTAProps {
  onOpenWaitlist: (source: 'final_cta') => void;
}

export default function FinalCTA({ onOpenWaitlist }: FinalCTAProps) {
  return (
    <section className="relative bg-cream py-24 md:py-32">
      <div className="mx-auto w-full max-w-4xl px-6 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-15%' }}
          transition={{ duration: 0.7, ease }}
        >
          <p className="font-display font-light text-sm text-text-secondary mb-8 flex items-center gap-3">
            <span className="tabular-nums">04</span>
            <span className="w-8 h-px bg-text-muted/50" />
            <span>Begin</span>
          </p>

          <h2 className="font-display font-light text-text-primary text-[40px] md:text-6xl lg:text-[64px] leading-[1.05] tracking-[-0.01em] max-w-[22ch] mb-10">
            Make your mistakes here.{' '}
            <span className="font-semibold">Not</span> in front of the officer.
          </h2>

          <Button onClick={() => onOpenWaitlist('final_cta')}>
            Notify me when it's ready
          </Button>

          <p className="font-sans text-xs text-text-muted mt-6">
            Free forever. No credit card. The grader is the same one used
            inside the app.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
